export type Redirect =
	| {
			match?: null;
			from: string;
			to: string;
	  }
	| {
			match: RegExp;
			from?: null;
			to: string;
	  };

export const Redirects: Redirect[] = [
	{
		from: '/praktisk-info/presse',
		to: '/presse'
	},
	{
		from: '/favicon-32x32.png',
		to: '/favicon.ico'
	},
	// {
	// 	from: '/pressebilleder',
	// 	to: '/presse/billeder'
	// },
	// {
	// 	from: '/pressebilleder/huset-og-salene',
	// 	to: '/presse/huset-og-salene'
	// },
	{
		from: '/praktisk-info/pausedrink',
		to: '/mad-og-drikke/pausedrink'
	},
	{
		from: '/praktisk-info/generel-kontakt/medarbejdere',
		to: '/praktisk-info/medarbejdere'
	},
	{
		from: '/praktisk-info/maestro-gammel',
		to: '/mad-og-drikke/maestro-brasserie'
	},
	{
		from: '/praktisk-info/maestro-brasserie-og-cocktails',
		to: '/mad-og-drikke/maestro-brasserie'
	},
	{
		from: '/praktisk-info/cafe-johan-r-gammel',
		to: '/mad-og-drikke/cafe-johan-r'
	},
	{
		from: '/praktisk-info/cafe-johan-r',
		to: '/mad-og-drikke/cafe-johan-r'
	},
	{
		from: '/kampagner/hvor-er-mit-nyhedsbrev',
		to: '/nyhedsbrev/hvor-er-mit-nyhedsbrev'
	},
	{
		from: '/kampagner/club-half-price-for-sponsorer',
		to: '/nyhedsbrev/club-half-price-for-sponsorer'
	},
	{
		from: '/praktisk-info/klub-hund',
		to: '/nyhedsbrev/klub-hund'
	},
	{
		from: '/praktisk-info/club-half-price',
		to: '/nyhedsbrev/club-half-price'
	},
	{
		from: '/praktisk-info/velkommen-til-club-half-price',
		to: '/nyhedsbrev/velkommen-til-club-half-price'
	},
	{
		from: '/praktisk-info/afmeld-nyhedsbrev',
		to: '/nyhedsbrev/afmeld-nyhedsbrev'
	},
	{
		from: '/praktisk-info/hvor-er-mit-nyhedsbrev',
		to: '/nyhedsbrev/hvor-er-mit-nyhedsbrev'
	},
	{
		from: '/praktisk-info/om-billetkob/information-vedrorende-refusion',
		to: '/praktisk-info/information-vedrorende-refusion'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-soger-studentermedhjaelper-til-kommunikation',
		to: '/ledige-stillinger/studentermedhjaelper-til-kommunikation'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-soger-medarbejder-til-publikumsafdelingen',
		to: '/ledige-stillinger/medarbejder-til-publikumsafdelingen'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-soger-erhvervs-og-eventkoordinator',
		to: '/ledige-stillinger/erhvervs-og-eventkoordinator'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-soger-maler',
		to: '/ledige-stillinger/maler'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-aarhus-soger-ny-kommunikationspraktikant',
		to: '/ledige-stillinger/kommunikationspraktikant'
	},
	{
		from: '/om-os/ledige-stillinger/musikhuset-soger-eventkoordinatorelev',
		to: '/ledige-stillinger/eventkoordinatorelev'
	},
	{
		from: '/en/about/halls-of-musikhuset',
		to: '/om-os/musikhusets-sale'
	},
	{
		from: '/om-os/leje-af-huset-og-salene',
		to: '/om-os/leje-af-musikhuset'
	},

	{
		from: '/kampagner/comedy',
		to: '/genre/comedy'
	},
	{
		from: '/kampagner/dans',
		to: '/genre/dans'
	},
	{
		from: '/kampagner/familie-born',
		to: '/genre/familie-born'
	},
	{
		from: '/kampagner/jazz',
		to: '/genre/jazz'
	},
	{
		from: '/kampagner/klassisk',
		to: '/genre/klassisk'
	},
	{
		from: '/kampagner/musical',
		to: '/genre/musical'
	},
	{
		from: '/kampagner/opera',
		to: '/genre/opera'
	},
	{
		from: '/kampagner/pop-rock',
		to: '/genre/pop-rock'
	},
	{
		from: '/kampagner/teater',
		to: '/genre/teater'
	},

	{
		match: /^\/om-os\/musikhusets-sale\/(.*)/,
		to: '/om-os/*'
	},
	{
		match: /^\/om-os\/sale-og-lokaler-til-erhverv\/(.+)/,
		to: '/om-os/*'
	},
	{
		match: /^\/pressebilleder\/huset-og-salene(.*)/,
		to: '/presse/huset-og-salene*'
	},
	{
		match: /^\/praktisk-info\/maestro-brasserie-og-cocktails(.*)/,
		to: '/mad-og-drikke*'
	},
	{
		match: /^\/arrangementer\/(.*)/,
		to: '/kalender/*'
	},
	{
		match: /^\/praktisk-info\/cafe-johan-r(.*)/,
		to: '/mad-og-drikke*'
	},
	{
		match: /^\/praktisk-info\/nyhedsbrev(.*)/,
		to: '/nyhedsbrev*'
	},
	{
		match: /^\/om-os\/ledige-stillinger(.*)/,
		to: '/ledige-stillinger*'
	},
	{
		match: /^\/jazzklubben(.*)/i,
		to: `/kampagner/jazzklubben*`
	},
	{
		match: /^\/spil(.*)/i,
		to: `/kampagner/quiz*`
	},
	{
		match: /^\/vind(.*)/i,
		to: `/kampagner/konkurrence*`
	},
	{
		match: /^\/kazoo(.*)/i,
		to: '/kampagner/kazoo*'
	},
	{
		match: /^\/live(.*)/i,
		to: '/om-os/live-fra-musikhuset*'
	},
	{
		match: /^\/praktisk-info\/parkering(.*)/i,
		to: '/praktisk-info/find-vej*'
	},
	{
		match: /^\/jazzfestival(.*)/i,
		to: '/kampagner/aarhus-jazz-festival*'
	},
	{
		match: /^\/find-vej(.*)/i,
		to: '/praktisk-info/find-vej*'
	},
	{
		match: /^\/vind(.*)/i,
		to: '/kampagner/konkurrence*'
	},
	{
		match: /^\/quiz(.*)/i,
		to: '/kampagner/leadfamly1*'
	},
	{
		match: /^\/syng-syng-syng(.*)/i,
		to: '/om-os/syng-syng-syng*'
	},
	{
		match: /^\/gratis(.*)/i,
		to: '/kalender?genre=gratis*'
	},
	{
		match: /^\/ecg(.*)/i,
		to: '/kampagner/european-choir-games*'
	},
	{
		match: /^\/maestro(.*)/i,
		to: '/mad-og-drikke/maestro-brasserie*'
	},
	{
		match: /^\/en\/?(.*)/i,
		to: '/*'
	},
	{
		from: '/nyheder-og-artikler/live-fra-musikhuset',
		to: '/om-os/live-fra-musikhuset'
	},
	{
		from: '/nyheder-og-artikler/syng-syng-syng',
		to: '/om-os/syng-syng-syng'
	},
	{
		from: '/nyheder-og-artikler/musikhuset-lytter',
		to: '/om-os/musikhuset-lytter'
	},
	{
		from: '/nyheder-og-artikler/musikhuset-favourite-places',
		to: '/om-os/musikhuset-favourite-places'
	},
	{
		from: '/nyheder-og-artikler/secret-places-i-musikhuset',
		to: '/om-os/secret-places-i-musikhuset'
	},
	{
		from: '/nyheder-og-artikler/musikhusets-take-away-koncerter',
		to: '/om-os/musikhusets-take-away-koncerter'
	}
];
